import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Contact } from "../../../../core/models/shared/contact";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-po-email-contacts",
  templateUrl: "./po-email-contacts.component.html",
  styleUrls: ["./po-email-contacts.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class PoEmailContactsComponent {
  @Input() contactsList: Contact[] = [];
  @Output() addCCEvent = new EventEmitter<Contact[]>();
  @Output() addTOEvent = new EventEmitter<Contact[]>();
  contactsSelected = [];

  addTO() {
    this.addTOEvent.emit(this.contactsSelected);
    this.contactsSelected = [];
  }
  addCC() {
    this.addCCEvent.emit(this.contactsSelected);
    this.contactsSelected = [];
  }
}
